import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router'
import { api } from '../api/client'
import type { Benutzer, Erfassung } from '../api/typen'
import AppRahmen from '../komponenten/AppRahmen'

/**
 * Startbildschirm: neue Erfassung beginnen oder eine offene fortsetzen. Weil der Stand
 * serverseitig liegt, taucht hier auch eine Erfassung auf, die jemand anderes begonnen hat
 * (Z-02) oder die auf einem anderen Geraet unterbrochen wurde (N-08).
 */
export default function Start() {
  const navigiere = useNavigate()

  const ich = useQuery({ queryKey: ['ich'], queryFn: () => api.get<Benutzer>('/api/auth/me') })
  const offene = useQuery({
    queryKey: ['erfassungen', 'offen'],
    queryFn: () => api.get<Erfassung[]>('/api/erfassungen?status=offen'),
  })

  return (
    <AppRahmen
      titel="Neoalto Fachlotse"
      unter={ich.data ? `Angemeldet als ${ich.data.benutzername}` : undefined}
      fuss={
        <button className="btn btn-primaer" onClick={() => navigiere('/erfassungen/neu')}>
          Neue Erfassung
        </button>
      }
    >
      <h1 className="s">Erfassung fortsetzen</h1>

      {offene.isPending && <div className="spinner" />}

      {offene.data?.length === 0 && (
        <p className="sek">
          Es läuft gerade keine Erfassung. Mit „Neue Erfassung“ unten beginnst du eine neue Aufnahme.
        </p>
      )}

      {offene.data?.map((erfassung) => (
        <button
          key={erfassung.id}
          className="karte"
          onClick={() => navigiere(`/erfassungen/${erfassung.id}`)}
        >
          <div className="zeile">
            <b>{erfassung.standort}</b>
            <span className="st st-arbeit">offen</span>
          </div>
          <span className="sek">
            {erfassung.anzahlVersorgungspunkte} Versorgungspunkte · {erfassung.anzahlSonderfaelle} Sonderfälle
          </span>
          <span className="sek">
            begonnen von {erfassung.erfasstVon} am {new Date(erfassung.erstelltAm).toLocaleString('de-DE')}
          </span>
        </button>
      ))}
    </AppRahmen>
  )
}
